import api from "../axiosIntercepture";

export const getAllActions = async () => {
    try {
        const response = await api.post("auth/actions/fetch");
        return response.data?.data;
    } catch (err) {
        throw err?.response?.data?.message;
    }
}
